import { listOptions, useConfig } from '../context/ConfigContext';

interface MultiListSelectProps {
  listKey: string;
  value: string[];
  onChange: (value: string[]) => void;
}

// A checkbox grid over one System > Lists key, for fields that can hold
// more than one value at once (e.g. a person's nationalities/languages) —
// as opposed to the single-value dropdowns listOptions() usually backs.
export default function MultiListSelect({ listKey, value, onChange }: MultiListSelectProps) {
  const { lists } = useConfig();
  const options = listOptions(lists, listKey);

  const toggle = (optionValue: string) => {
    if (value.includes(optionValue)) onChange(value.filter((v) => v !== optionValue));
    else onChange([...value, optionValue]);
  };

  return (
    <div className="form-grid">
      {options.map((option) => (
        <label key={option.value} className="checkbox-label">
          <input type="checkbox" checked={value.includes(option.value)} onChange={() => toggle(option.value)} />
          {option.label}
        </label>
      ))}
      {options.length === 0 && (
        <p className="muted span-2">No options configured yet — add some under System &gt; Lists.</p>
      )}
    </div>
  );
}
